// extracted by mini-css-extract-plugin
export default {"chooseCard":"ChooseCard_chooseCard__e3v9C","chooseCard__img":"ChooseCard_chooseCard__img__jGG32","chooseCard__title":"ChooseCard_chooseCard__title__E9XId"};